import * as React from 'react';

function SvgBookingPayment(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 22" {...props}>
      <g fill="none">
        <path fill="#FCCE01" d="M6 7.333h16.667v11.333H6z" />
        <path
          d="M9.208.401l7.7 4.562h3.893c1.681 0 3.049 1.403 3.049 3.128v10.65c-.003 1.725-1.37 3.128-3.049 3.128H3.072c-.049 0-.098-.001-.146-.004v.004c-1.612 0-2.923-1.345-2.923-3h.023a3.25 3.25 0 01-.002-.128v-3.585a.88.88 0 01.869-.891.88.88 0 01.869.891v3.588c0 .741.588 1.345 1.31 1.345h17.73c.722 0 1.31-.604 1.31-1.345V8.09c0-.707-.536-1.29-1.213-1.341h-4.221v-.004H3.071c-.722 0-1.31.604-1.31 1.345v3.876a.88.88 0 01-.87.891.88.88 0 01-.868-.891V8.09l.003-.129H0c0-1.654 1.31-2.999 2.923-2.999h.344l1.949-3.465C6.022.068 7.813-.426 9.208.401zm10.81 16.722a.88.88 0 01.87.892.881.881 0 01-.87.891h-2.543a.88.88 0 01-.869-.891.88.88 0 01.87-.892h2.543zm-5.29 0a.88.88 0 01.87.892c-.004.493-.392.891-.87.891h-2.543a.88.88 0 01-.87-.891.88.88 0 01.87-.892h2.543zm5.27-8.447a.88.88 0 01.869.892.88.88 0 01-.869.892H3.872a.88.88 0 01-.868-.892.88.88 0 01.868-.892h16.126zM6.718 2.39L5.27 4.963h8.165L8.339 1.945a1.172 1.172 0 00-1.621.445z"
          fill="#4C4C4C"
        />
      </g>
    </svg>
  );
}

export default SvgBookingPayment;
